export const normalizeCategoryData = (data: any) => {
    return data?.serviceCategories?.items || [];
};
